// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Table, Button, Modal, Form } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar'
// const PoojaManagement = () => {
//   const [poojas, setPoojas] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [modalData, setModalData] = useState({ id: '', pname: '', pprice: '', pduration: '' });
//   const [newPooja, setNewPooja] = useState({ pname: '', pprice: '', pduration: '' });
//   const [message, setMessage] = useState('');

//   // Fetch Poojas
//   useEffect(() => {
//     axios.get('https://posapi.emedha.in/api/pooja')
//       .then((response) => setPoojas(response.data))
//       .catch((error) => console.error('Error fetching poojas:', error));
//   }, []);

//   // Handle input change for new pooja
//   const handleNewPoojaChange = (e) => {
//     const { name, value } = e.target;
//     setNewPooja((prevState) => ({ ...prevState, [name]: value }));
//   };

//   // Handle input change for modal
//   const handleModalChange = (e) => {
//     const { name, value } = e.target;
//     setModalData((prevState) => ({ ...prevState, [name]: value }));
//   };

//   // Submit new pooja
//   const handleSubmitNewPooja = (e) => {
//     e.preventDefault();
//     axios.post('https://posapi.emedha.in/api/pooja', newPooja)
//       .then((response) => {
//         setMessage(response.data.message);
//         setNewPooja({ pname: '', pprice: '', pduration: '' }); // Clear form
//         axios.get('https://posapi.emedha.in/api/pooja')
//           .then((response) => setPoojas(response.data))
//           .catch((error) => console.error('Error fetching poojas:', error));
//       })
//       .catch((error) => console.error('Error adding pooja:', error));
//   };

//   // Handle update pooja
//   const handleUpdatePooja = (e) => {
//     e.preventDefault();
//     axios.put(`https://posapi.emedha.in/api/pooja/${modalData.id}`, modalData)
//       .then((response) => {
//         setMessage(response.data.message);
//         setShowModal(false);
//         axios.get('https://posapi.emedha.in/api/pooja')
//           .then((response) => setPoojas(response.data))
//           .catch((error) => console.error('Error fetching poojas:', error));
//       })
//       .catch((error) => console.error('Error updating pooja:', error));
//   };

//   // Handle delete pooja
//   const handleDeletePooja = (id) => {
//     if (window.confirm('Do you want to delete this pooja?')) {
//       axios.delete(`https://posapi.emedha.in/api/pooja/${id}`)
//         .then((response) => {
//           setMessage(response.data.message);
//           axios.get('https://posapi.emedha.in/api/pooja')
//             .then((response) => setPoojas(response.data))
//             .catch((error) => console.error('Error fetching poojas:', error));
//         })
//         .catch((error) => console.error('Error deleting pooja:', error));
//     }
//   };

//   // Open modal to edit pooja
//   const openEditModal = (pooja) => {
//     setModalData(pooja);
//     setShowModal(true);
//   };

//   return (
//     <>
//      <Sidebar />
//      <div id="main">
//     <div className="container">
//       <h2>Manage Pooja</h2>

//       {/* Display Success/Error Message */}
//       {message && <div className="alert alert-info">{message}</div>}

//       {/* Create New Pooja */}
//       <form onSubmit={handleSubmitNewPooja}>
//         <Form.Group>
//           <Form.Label>Pooja Name</Form.Label>
//           <Form.Control type="text" name="pname" value={newPooja.pname} onChange={handleNewPoojaChange} required />
//         </Form.Group>
//         <Form.Group>
//           <Form.Label>Price</Form.Label>
//           <Form.Control type="text" name="pprice" value={newPooja.pprice} onChange={handleNewPoojaChange} required />
//         </Form.Group>
//         <Form.Group>
//           <Form.Label>Duration</Form.Label>
//           <Form.Control type="text" name="pduration" value={newPooja.pduration} onChange={handleNewPoojaChange} required />
//         </Form.Group>
//         <Button type="submit">Create Pooja</Button>
//       </form>

//       {/* Pooja Table */}
//       <Table striped bordered hover>
//         <thead>
//           <tr>
//             <th>S.No</th>
//             <th>Pooja Name</th>
//             <th>Price</th>
//             <th>Duration</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {poojas.map((pooja, index) => (
//             <tr key={pooja.pid}>
//               <td>{index + 1}</td>
//               <td>{pooja.pname}</td>
//               <td>{pooja.pprice}</td>
//               <td>{pooja.pduration}</td>
//               <td>
//                 <Button onClick={() => openEditModal(pooja)}>Edit</Button>
//                 <Button onClick={() => handleDeletePooja(pooja.pid)} variant="danger">Delete</Button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>

//       {/* Edit Pooja Modal */}
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Pooja</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleUpdatePooja}>
//             <Form.Group>
//               <Form.Label>Pooja Name</Form.Label>
//               <Form.Control type="text" name="pname" value={modalData.pname} onChange={handleModalChange} required />
//             </Form.Group>
//             <Form.Group>
//               <Form.Label>Price</Form.Label>
//               <Form.Control type="text" name="pprice" value={modalData.pprice} onChange={handleModalChange} required />
//             </Form.Group>
//             <Form.Group>
//               <Form.Label>Duration</Form.Label>
//               <Form.Control type="text" name="pduration" value={modalData.pduration} onChange={handleModalChange} required />
//             </Form.Group>
//             <Button type="submit">Update Pooja</Button>
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </div>
//     </div>
//     </>
//   );
// };

// export default PoojaManagement;



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Table, Button, Modal, Form, Pagination, Dropdown, InputGroup, FormControl } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';
// import { FaOm } from "react-icons/fa6";
// import { LuTextSearch } from "react-icons/lu";
// import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
// import { RiMoneyRupeeCircleLine } from "react-icons/ri";
// import { GiDuration } from "react-icons/gi";



// const PoojaManagement = () => {
//   const [poojas, setPoojas] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [modalData, setModalData] = useState({ id: '', pname: '', pprice: '', pduration: '' });
//   const [newPooja, setNewPooja] = useState({ pname: '', pprice: '', pduration: '' });
//   const [message, setMessage] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [searchQuery, setSearchQuery] = useState('');  // Add search state

//   // Fetch Poojas
//   useEffect(() => {
//     axios.get('https://posapi.emedha.in/api/pooja')
//       .then((response) => setPoojas(response.data))
//       .catch((error) => console.error('Error fetching poojas:', error));
//   }, []);

//   // Handle input change for new pooja
//   const handleNewPoojaChange = (e) => {
//     const { name, value } = e.target;
//     setNewPooja((prevState) => ({ ...prevState, [name]: value }));
//   };

//   // Handle input change for modal
//   const handleModalChange = (e) => {
//     const { name, value } = e.target;
//     setModalData((prevState) => ({ ...prevState, [name]: value }));
//   };

//   // Submit new pooja
//   const handleSubmitNewPooja = (e) => {
//     e.preventDefault();
//     axios.post('https://posapi.emedha.in/api/pooja', newPooja)
//       .then((response) => {
//         setMessage(response.data.message);
//         setNewPooja({ pname: '', pprice: '', pduration: '' });
//         axios.get('https://posapi.emedha.in/api/pooja')
//           .then((response) => setPoojas(response.data))
//           .catch((error) => console.error('Error fetching poojas:', error));
//       })
//       .catch((error) => console.error('Error adding pooja:', error));
//   };

//   // Handle update pooja
//   const handleUpdatePooja = (e) => {
//     e.preventDefault();
//     axios.put(`https://posapi.emedha.in/api/pooja/${modalData.pid}`, modalData)
//       .then((response) => {
//         setMessage(response.data.message);
//         setShowModal(false);
//         axios.get('https://posapi.emedha.in/api/pooja')
//           .then((response) => setPoojas(response.data))
//           .catch((error) => console.error('Error fetching poojas:', error));
//       })
//       .catch((error) => console.error('Error updating pooja:', error));
//   };

//   // Handle delete pooja
//   const handleDeletePooja = (id) => {
//     if (window.confirm('Do you want to delete this pooja?')) {
//       axios.delete(`https://posapi.emedha.in/api/pooja/${id}`)
//         .then((response) => {
//           setMessage(response.data.message);
//           axios.get('https://posapi.emedha.in/api/pooja')
//             .then((response) => setPoojas(response.data))
//             .catch((error) => console.error('Error fetching poojas:', error));
//         })
//         .catch((error) => console.error('Error deleting pooja:', error));
//     }
//   };

//   // Open modal to edit pooja
//   const openEditModal = (pooja) => {
//     setModalData(pooja);
//     setShowModal(true);
//   };

//   // Handle pagination logic
//   const totalPages = Math.ceil(poojas.length / itemsPerPage);
//   const indexOfLastPooja = currentPage * itemsPerPage;
//   const indexOfFirstPooja = indexOfLastPooja - itemsPerPage;

//   // Filter poojas based on search query
//   const filteredPoojas = poojas.filter(pooja => {
//     const query = searchQuery.toLowerCase();
//     return (
//       pooja.pname.toLowerCase().includes(query)||pooja.pprice.toLowerCase().includes(query)||pooja.pduration.toLowerCase().includes(query)
//     );
//   });

//   const currentPoojas = filteredPoojas.slice(indexOfFirstPooja, indexOfLastPooja);

//   // Change items per page
//   const handleItemsPerPageChange = (num) => {
//     setItemsPerPage(num);
//     setCurrentPage(1); // Reset to first page
//   };

//   // Change page
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   return (
//     <>
//       <Sidebar />
//       <div id="main">
//         <div className="container">
//           <h2>Manage Pooja</h2>

//           {/* Display Success/Error Message */}
//           {message && <div className="alert alert-info">{message}</div>}

//           {/* Search Bar */}
//           <InputGroup className="mb-3">
//             <InputGroup.Text> <LuTextSearch style={{margin:'5px'}}/> Search</InputGroup.Text>
//             <FormControl
//               placeholder="Search Pooja Name, Price, Duration"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </InputGroup>

//           {/* Create New Pooja */}
//           <form onSubmit={handleSubmitNewPooja}>
//             <Form.Group>
//               <Form.Label>Pooja Name  <MdOutlineDriveFileRenameOutline/></Form.Label>
//               <Form.Control type="text" name="pname" value={newPooja.pname} onChange={handleNewPoojaChange} required />
//             </Form.Group>
//             <Form.Group>
//               <Form.Label>Price  <RiMoneyRupeeCircleLine/></Form.Label>
//               <Form.Control type="text" name="pprice" value={newPooja.pprice} onChange={handleNewPoojaChange} required />
//             </Form.Group>
//             <Form.Group>
//               <Form.Label>Duration  <GiDuration/></Form.Label>
//               <Form.Control type="text" name="pduration" value={newPooja.pduration} onChange={handleNewPoojaChange} required />
//             </Form.Group>
//             <Button type="submit">Create Pooja</Button>
//           </form>

//           {/* Items per Page Dropdown */}
//           <div className="d-flex justify-content-end my-3">
//             <Dropdown>
//               <Dropdown.Toggle variant="secondary" id="dropdown-basic">
//                 Items per page: {itemsPerPage}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 <Dropdown.Item onClick={() => handleItemsPerPageChange(5)}>5</Dropdown.Item>
//                 <Dropdown.Item onClick={() => handleItemsPerPageChange(10)}>10</Dropdown.Item>
//                 <Dropdown.Item onClick={() => handleItemsPerPageChange(20)}>20</Dropdown.Item>
//                 <Dropdown.Item onClick={() => handleItemsPerPageChange(30)}>30</Dropdown.Item>
//               </Dropdown.Menu>
//             </Dropdown>
//           </div>

//           {/* Pooja Table */}
//           <Table striped bordered hover responsive>
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Pooja Name</th>
//                 <th>Price</th>
//                 <th>Duration</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentPoojas.map((pooja, index) => (
//                 <tr key={pooja.pid}>
//                  <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
//                   <td>{pooja.pname}</td>
//                   <td>{pooja.pprice}</td>
//                   <td>{pooja.pduration}</td>
//                   <td>
//                     <Button onClick={() => openEditModal(pooja)}>Edit</Button>
//                     <Button onClick={() => handleDeletePooja(pooja.pid)} variant="danger">Delete</Button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>

//           {/* Pagination */}
//           <Pagination>
//             {Array.from({ length: totalPages }, (_, index) => (
//               <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => handlePageChange(index + 1)}>
//                 {index + 1}
//               </Pagination.Item>
//             ))}
//           </Pagination>

//           {/* Edit Pooja Modal */}
//           <Modal show={showModal} onHide={() => setShowModal(false)}>
//             <Modal.Header closeButton>
//               <Modal.Title>Edit Pooja</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//               <Form onSubmit={handleUpdatePooja}>
//                 <Form.Group>
//                   <Form.Label>Pooja Name</Form.Label>
//                   <Form.Control type="text" name="pname" value={modalData.pname} onChange={handleModalChange} required />
//                 </Form.Group>
//                 <Form.Group>
//                   <Form.Label>Price</Form.Label>
//                   <Form.Control type="text" name="pprice" value={modalData.pprice} onChange={handleModalChange} required />
//                 </Form.Group>
//                 <Form.Group>
//                   <Form.Label>Duration</Form.Label>
//                   <Form.Control type="text" name="pduration" value={modalData.pduration} onChange={handleModalChange} required />
//                 </Form.Group>
//                 <Button type="submit">Update Pooja</Button>
//               </Form>
//             </Modal.Body>
//           </Modal>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PoojaManagement;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar/Sidebar';

// SVG Icons helper
const Icons = {
  Plus: (size = 16) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  ),
  Search: (size = 16) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  Edit2: (size = 14) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
    </svg>
  ),
  Trash2: (size = 14) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  )
};

const PoojaManagement = () => {
  const [poojas, setPoojas] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ pid: '', pname: '', pprice: '', pduration: '' });
  const [newPooja, setNewPooja] = useState({ pname: '', pprice: '', pduration: '' });
  const [message, setMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);

  // Responsive breakpoint listener
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 1. Fetch Poojas (API GET)
  const fetchPoojas = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://posapi.emedha.in/api/pooja');
      setPoojas(response.data || []);
    } catch (error) {
      console.error('Error fetching poojas:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPoojas();
  }, []);

  // Input change handlers
  const handleNewPoojaChange = (e) => {
    const { name, value } = e.target;
    setNewPooja((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setModalData((prevState) => ({ ...prevState, [name]: value }));
  };

  // 2. Submit new pooja (API POST)
  const handleSubmitNewPooja = (e) => {
    e.preventDefault();
    if (!newPooja.pname.trim() || !newPooja.pprice.toString().trim() || !newPooja.pduration.trim()) {
      alert('All fields are required');
      return;
    }

    axios.post('https://posapi.emedha.in/api/pooja', newPooja)
      .then((response) => {
        setMessage(response.data.message);
        alert(response.data.message || 'Pooja added successfully');
        setNewPooja({ pname: '', pprice: '', pduration: '' });
        setShowAddModal(false);
        fetchPoojas();
      })
      .catch((error) => {
        console.error('Error adding pooja:', error);
        alert('Error adding pooja');
      });
  };

  // 3. Handle update pooja (API PUT)
  const handleUpdatePooja = (e) => {
    e.preventDefault();
    axios.put(`https://posapi.emedha.in/api/pooja/${modalData.pid}`, modalData)
      .then((response) => {
        setMessage(response.data.message);
        alert(response.data.message || 'Pooja updated successfully');
        setShowModal(false);
        fetchPoojas();
      })
      .catch((error) => {
        console.error('Error updating pooja:', error);
        alert('Error updating pooja');
      });
  };

  // 4. Handle delete pooja (API DELETE)
  const handleDeletePooja = (id) => {
    if (window.confirm('Do you want to delete this pooja?')) {
      axios.delete(`https://posapi.emedha.in/api/pooja/${id}`)
        .then((response) => {
          setMessage(response.data.message);
          alert(response.data.message || 'Pooja deleted successfully');
          fetchPoojas();
          if (currentPoojas.length === 1 && currentPage > 1) {
            setCurrentPage(currentPage - 1);
          }
        })
        .catch((error) => {
          console.error('Error deleting pooja:', error);
          alert('Error deleting pooja');
        });
    }
  };

  const openEditModal = (pooja) => {
    setModalData(pooja);
    setShowModal(true);
  };

  // Filter and Pagination Logic
  const filteredPoojas = poojas.filter(pooja => {
    const query = searchQuery.toLowerCase();
    return (
      (pooja.pname && pooja.pname.toLowerCase().includes(query)) ||
      (pooja.pprice && pooja.pprice.toString().toLowerCase().includes(query)) ||
      (pooja.pduration && pooja.pduration.toLowerCase().includes(query))
    );
  });

  const totalPages = Math.ceil(filteredPoojas.length / itemsPerPage) || 1;
  const currentPoojas = filteredPoojas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Smart Pagination range calculation
  const getPaginationItems = () => {
    if (totalPages <= 8) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 4) {
      return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    if (currentPage >= totalPages - 3) {
      return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
  };

  return (
    <div 
    //style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
    >
      <Sidebar />

      <div
        // id="main"
        // style={{
        //   flex: 1,
        //   display: 'flex',
        //   flexDirection: 'column',
        //   minWidth: 0,
        //   fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        // }}
      >
        <div
          style={{
            padding: isMobile ? '16px' : '28px',
            maxWidth: '1280px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {/* Header Bar */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              justifyContent: 'space-between',
              gap: '16px',
              width: '100%'
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? '22px' : '26px',
                  fontWeight: '700',
                  color: '#111827',
                  fontFamily: "'Cinzel', serif"
                }}
              >
                Manage Pooja
              </h2>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
                {poojas.length} total poojas configured
              </p>
            </div>

            <button
              onClick={() => setShowAddModal(true)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '10px 20px',
                borderRadius: '12px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#ffffff',
                background: 'linear-gradient(135deg, #f97316, #c2410c)',
                boxShadow: '0 4px 16px rgba(249, 115, 22, 0.3)',
                border: 'none',
                cursor: 'pointer',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              {Icons.Plus(16)}
              <span>Add Pooja</span>
            </button>
          </div>

          {/* Controls Bar: Search & Page Limit */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              justifyContent: 'space-between',
              alignItems: isMobile ? 'stretch' : 'center',
              gap: '12px',
              width: '100%'
            }}
          >
            {/* Search Input */}
            <div style={{ position: 'relative', flex: 1, maxWidth: isMobile ? '100%' : '420px' }}>
              <span
                style={{
                  position: 'absolute',
                  left: '14px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {Icons.Search(16)}
              </span>
              <input
                type="search"
                placeholder="Search poojas…"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
                style={{
                  width: '100%',
                  padding: '11px 16px 11px 40px',
                  borderRadius: '12px',
                  border: '1px solid #e5e7eb',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: '#fdf8f3',
                  color: '#1f2937',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            {/* Entries Dropdown */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#4b5563' }}>
              <span>Show</span>
              <select
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={{
                  padding: '8px 12px',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  fontSize: '14px',
                  backgroundColor: '#ffffff',
                  color: '#1f2937',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
              </select>
              <span>entries</span>
            </div>
          </div>

          {/* Table Container */}
          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px 0', color: '#6b7280', fontSize: '14px' }}>
              Loading poojas...
            </div>
          ) : (
            <>
              <div
                style={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #ffedd5',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                  width: '100%',
                  overflow: 'hidden'
                }}
              >
                <div style={{ width: '100%', overflowX: 'auto' }}>
                  <table
                    style={{
                      width: '100%',
                      minWidth: '650px',
                      borderCollapse: 'collapse',
                      textAlign: 'left'
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: 'rgba(255, 247, 237, 0.6)',
                          borderBottom: '1px solid #ffedd5',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#374151',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em'
                        }}
                      >
                        <th style={{ padding: '14px 20px', width: '70px' }}>S.No</th>
                        <th style={{ padding: '14px 20px' }}>Pooja Name</th>
                        <th style={{ padding: '14px 20px', width: '140px' }}>Price</th>
                        <th style={{ padding: '14px 20px', width: '140px' }}>Duration</th>
                        <th style={{ padding: '14px 20px', textAlign: 'right', width: '110px' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody style={{ fontSize: '14px' }}>
                      {currentPoojas.length > 0 ? (
                        currentPoojas.map((pooja, index) => {
                          const serialNumber = (currentPage - 1) * itemsPerPage + index + 1;
                          return (
                            <tr
                              key={pooja.pid || index}
                              style={{
                                borderBottom: '1px solid #fff7ed',
                                backgroundColor: '#ffffff'
                              }}
                            >
                              <td style={{ padding: '16px 20px', color: '#6b7280', fontWeight: '500' }}>
                                {serialNumber}
                              </td>
                              <td style={{ padding: '16px 20px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                  <div
                                    style={{
                                      width: '36px',
                                      height: '36px',
                                      borderRadius: '10px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      backgroundColor: '#fff7ed',
                                      fontSize: '18px',
                                      flexShrink: 0
                                    }}
                                  >
                                    🕉️
                                  </div>
                                  <span style={{ fontWeight: '600', color: '#111827' }}>
                                    {pooja.pname}
                                  </span>
                                </div>
                              </td>
                              <td style={{ padding: '16px 20px' }}>
                                <span style={{ fontWeight: '700', color: '#ea580c' }}>
                                  ₹{Number(pooja.pprice || 0).toLocaleString()}
                                </span>
                              </td>
                              <td style={{ padding: '16px 20px' }}>
                                <span
                                  style={{
                                    display: 'inline-block',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    padding: '4px 10px',
                                    borderRadius: '9999px',
                                    backgroundColor: '#fff7ed',
                                    color: '#c2410c'
                                  }}
                                >
                                  {pooja.pduration}
                                </span>
                              </td>
                              <td style={{ padding: '16px 20px', textAlign: 'right' }}>
                                <div style={{ display: 'inline-flex', gap: '8px', justifyContent: 'flex-end' }}>
                                  <button
                                    onClick={() => openEditModal(pooja)}
                                    title="Edit Pooja"
                                    style={{
                                      width: '34px',
                                      height: '34px',
                                      borderRadius: '8px',
                                      backgroundColor: '#fff7ed',
                                      color: '#ea580c',
                                      border: 'none',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    {Icons.Edit2(14)}
                                  </button>
                                  <button
                                    onClick={() => handleDeletePooja(pooja.pid)}
                                    title="Delete Pooja"
                                    style={{
                                      width: '34px',
                                      height: '34px',
                                      borderRadius: '8px',
                                      backgroundColor: '#fef2f2',
                                      color: '#ef4444',
                                      border: 'none',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    {Icons.Trash2(14)}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan={5}
                            style={{
                              textAlign: 'center',
                              padding: '36px 0',
                              color: '#9ca3af',
                              fontSize: '14px'
                            }}
                          >
                            No poojas found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Smart Pagination Section */}
              {totalPages > 1 && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    paddingTop: '12px',
                    width: '100%',
                    flexWrap: 'wrap'
                  }}
                >
                  <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>
                    Showing {(currentPage - 1) * itemsPerPage + 1} to{' '}
                    {Math.min(currentPage * itemsPerPage, filteredPoojas.length)} of {filteredPoojas.length} poojas
                  </p>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                    <button
                      onClick={() => setCurrentPage(1)}
                      disabled={currentPage === 1}
                      title="First Page"
                      style={{
                        padding: '6px 10px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                        opacity: currentPage === 1 ? 0.4 : 1
                      }}
                    >
                      « First
                    </button>

                    <button
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                      title="Previous Page"
                      style={{
                        padding: '6px 12px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                        opacity: currentPage === 1 ? 0.4 : 1
                      }}
                    >
                      Prev
                    </button>

                    {getPaginationItems().map((item, index) => {
                      if (item === '...') {
                        return (
                          <span
                            key={`ellipsis-${index}`}
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '28px',
                              height: '32px',
                              fontSize: '14px',
                              color: '#9ca3af',
                              userSelect: 'none'
                            }}
                          >
                            ...
                          </span>
                        );
                      }

                      const isCurrent = currentPage === item;
                      return (
                        <button
                          key={`page-${item}`}
                          onClick={() => setCurrentPage(item)}
                          style={{
                            minWidth: '32px',
                            height: '32px',
                            padding: '0 6px',
                            borderRadius: '8px',
                            fontSize: '12px',
                            fontWeight: isCurrent ? '700' : '500',
                            cursor: 'pointer',
                            border: isCurrent ? 'none' : '1px solid #e5e7eb',
                            backgroundColor: isCurrent ? '#f97316' : '#ffffff',
                            color: isCurrent ? '#ffffff' : '#4b5563',
                            boxShadow: isCurrent ? '0 2px 8px rgba(249, 115, 22, 0.3)' : 'none',
                            transition: 'all 0.15s ease'
                          }}
                        >
                          {item}
                        </button>
                      );
                    })}

                    <button
                      onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      title="Next Page"
                      style={{
                        padding: '6px 12px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                        opacity: currentPage === totalPages ? 0.4 : 1
                      }}
                    >
                      Next
                    </button>

                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      disabled={currentPage === totalPages}
                      title="Last Page"
                      style={{
                        padding: '6px 10px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '12px',
                        fontWeight: '500',
                        color: '#4b5563',
                        backgroundColor: '#ffffff',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                        opacity: currentPage === totalPages ? 0.4 : 1
                      }}
                    >
                      Last »
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* --- Add Pooja Modal --- */}
      {showAddModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            backdropFilter: 'blur(2px)'
          }}
          onClick={() => setShowAddModal(false)}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              padding: '24px',
              width: '100%',
              maxWidth: '440px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
              boxSizing: 'border-box'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              style={{
                margin: '0 0 16px 0',
                fontSize: '18px',
                fontWeight: '700',
                color: '#111827',
                fontFamily: "'Cinzel', serif"
              }}
            >
              Add Pooja
            </h3>
            <form onSubmit={handleSubmitNewPooja} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Pooja Name
                </label>
                <input
                  type="text"
                  name="pname"
                  value={newPooja.pname}
                  onChange={handleNewPoojaChange}
                  placeholder="e.g. Rudrabhishek"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Price (₹)
                </label>
                <input
                  type="number"
                  name="pprice"
                  value={newPooja.pprice}
                  onChange={handleNewPoojaChange}
                  placeholder="e.g. 1500"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Duration
                </label>
                <input
                  type="text"
                  name="pduration"
                  value={newPooja.pduration}
                  onChange={handleNewPoojaChange}
                  placeholder="e.g. 2 hrs"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div style={{ display: 'flex', gap: '12px', marginTop: '10px' }}>
                <button
                  type="button"
                  onClick={() => setShowAddModal(false)}
                  style={{
                    flex: 1,
                    padding: '10px 16px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#4b5563',
                    backgroundColor: '#ffffff',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    flex: 1,
                    padding: '10px 16px',
                    borderRadius: '10px',
                    border: 'none',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#ffffff',
                    background: 'linear-gradient(135deg, #f97316, #c2410c)',
                    cursor: 'pointer'
                  }}
                >
                  Save Pooja
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* --- Edit Pooja Modal --- */}
      {showModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            backdropFilter: 'blur(2px)'
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              padding: '24px',
              width: '100%',
              maxWidth: '440px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
              boxSizing: 'border-box'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3
              style={{
                margin: '0 0 16px 0',
                fontSize: '18px',
                fontWeight: '700',
                color: '#111827',
                fontFamily: "'Cinzel', serif"
              }}
            >
              Edit Pooja
            </h3>
            <form onSubmit={handleUpdatePooja} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Pooja Name
                </label>
                <input
                  type="text"
                  name="pname"
                  value={modalData.pname || ''}
                  onChange={handleModalChange}
                  placeholder="Enter pooja name"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Price (₹)
                </label>
                <input
                  type="number"
                  name="pprice"
                  value={modalData.pprice || ''}
                  onChange={handleModalChange}
                  placeholder="Enter price"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                  Duration
                </label>
                <input
                  type="text"
                  name="pduration"
                  value={modalData.pduration || ''}
                  onChange={handleModalChange}
                  placeholder="Enter duration"
                  required
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div style={{ display: 'flex', gap: '12px', marginTop: '10px' }}>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  style={{
                    flex: 1,
                    padding: '10px 16px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#4b5563',
                    backgroundColor: '#ffffff',
                    cursor: 'pointer'
                  }}
                >
                  Close
                </button>
                <button
                  type="submit"
                  style={{
                    flex: 1,
                    padding: '10px 16px',
                    borderRadius: '10px',
                    border: 'none',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#ffffff',
                    background: 'linear-gradient(135deg, #f97316, #c2410c)',
                    cursor: 'pointer'
                  }}
                >
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default PoojaManagement;



// import React, { useState, useEffect } from "react";

// // Built-in SVG Icons
// const Icons = {
//   Plus: (size = 16) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <line x1="12" y1="5" x2="12" y2="19"></line>
//       <line x1="5" y1="12" x2="19" y2="12"></line>
//     </svg>
//   ),
//   Search: (size = 16) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <circle cx="11" cy="11" r="8"></circle>
//       <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
//     </svg>
//   ),
//   Edit2: (size = 14) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
//     </svg>
//   ),
//   Trash2: (size = 14) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="3 6 5 6 21 6"></polyline>
//       <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
//       <line x1="10" y1="11" x2="10" y2="17"></line>
//       <line x1="14" y1="11" x2="14" y2="17"></line>
//     </svg>
//   )
// };

// export default function ManagePoojaScreen() {
//   const [poojas, setPoojas] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Form states
//   const [poojaName, setPoojaName] = useState("");
//   const [price, setPrice] = useState("");
//   const [duration, setDuration] = useState("");
//   const [editingId, setEditingId] = useState(null);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 6;

//   // Responsive breakpoint listener
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const API_URL = "https://pos.emedha.in/pooja";

//   // 1. READ / FETCH Poojas
//   useEffect(() => {
//     fetchPoojas();
//   }, []);

//   const fetchPoojas = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ table: "tbl_pooja", action: "get" })
//       });
//       const data = await response.json();

//       if (data && data.rows) {
//         const formatted = data.rows.map((row, index) => ({
//           id: row.pooja_id || index + 1,
//           name: row.pooja_name,
//           price: Number(row.pooja_price) || 0,
//           duration: row.pooja_duration || "1 hr"
//         }));
//         setPoojas(formatted);
//       }
//     } catch (error) {
//       console.error("Failed to fetch poojas:", error);
//       setPoojas([
//         { id: 1, name: "Rudrabhishek", price: 1500, duration: "2 hrs" },
//         { id: 2, name: "Satyanarayan Puja", price: 800, duration: "1.5 hrs" },
//         { id: 3, name: "Ganesh Homam", price: 3200, duration: "3 hrs" },
//         { id: 4, name: "Lakshmi Puja", price: 600, duration: "1 hr" },
//         { id: 5, name: "Navagraha Homam", price: 5000, duration: "4 hrs" },
//         { id: 6, name: "Sudarshana Homam", price: 8000, duration: "5 hrs" },
//         { id: 7, name: "Mrityunjaya Homam", price: 12000, duration: "6 hrs" }
//       ]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filtered = poojas.filter((p) =>
//     p.name.toLowerCase().includes(search.toLowerCase())
//   );

//   const totalPages = Math.ceil(filtered.length / itemsPerPage) || 1;
//   const paginatedPoojas = filtered.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleSearchChange = (e) => {
//     setSearch(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleOpenAddModal = () => {
//     setEditingId(null);
//     setPoojaName("");
//     setPrice("");
//     setDuration("");
//     setShowModal(true);
//   };

//   const handleOpenEditModal = (p) => {
//     setEditingId(p.id);
//     setPoojaName(p.name);
//     setPrice(p.price.toString());
//     setDuration(p.duration);
//     setShowModal(true);
//   };

//   // 2. CREATE & UPDATE Pooja
//   const handleSavePooja = async () => {
//     if (!poojaName.trim() || !price.trim() || !duration.trim()) return;

//     const payloadId = editingId !== null ? editingId : Date.now();

//     const payload = {
//       table: "tbl_pooja",
//       rows: [
//         {
//           pooja_id: payloadId,
//           pooja_name: poojaName,
//           pooja_price: Number(price),
//           pooja_duration: duration
//         }
//       ]
//     };

//     try {
//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });

//       if (response.ok) {
//         if (editingId !== null) {
//           setPoojas(
//             poojas.map((p) =>
//               p.id === editingId
//                 ? { ...p, name: poojaName, price: Number(price), duration }
//                 : p
//             )
//           );
//         } else {
//           const newPooja = {
//             id: payloadId,
//             name: poojaName,
//             price: Number(price),
//             duration
//           };
//           setPoojas([newPooja, ...poojas]);
//         }
//       }
//     } catch (error) {
//       console.error("Failed to save pooja:", error);
//     }

//     setShowModal(false);
//     setPoojaName("");
//     setPrice("");
//     setDuration("");
//     setEditingId(null);
//   };

//   // 3. DELETE Pooja
//   const handleDeletePooja = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this pooja?")) return;

//     const payload = {
//       table: "tbl_pooja",
//       action: "delete",
//       pooja_id: id
//     };

//     try {
//       await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });

//       setPoojas(poojas.filter((p) => p.id !== id));
//       if (paginatedPoojas.length === 1 && currentPage > 1) {
//         setCurrentPage(currentPage - 1);
//       }
//     } catch (error) {
//       console.error("Failed to delete pooja:", error);
//     }
//   };

//   // 4. Smart Pagination Calculation
//   const getPaginationItems = () => {
//     if (totalPages <= 8) {
//       return Array.from({ length: totalPages }, (_, i) => i + 1);
//     }
//     if (currentPage <= 4) {
//       return [1, 2, 3, 4, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
//     }
//     if (currentPage >= totalPages - 3) {
//       return [1, 2, 3, 4, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
//     }
//     return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
//   };

//   return (
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         gap: "20px",
//         width: "100%",
//         maxWidth: "1280px",
//         margin: "0 auto",
//         padding: isMobile ? "16px" : "24px 32px",
//         boxSizing: "border-box",
//         fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
//       }}
//     >
//       {/* Header Bar */}
//       <div
//         style={{
//           display: "flex",
//           flexDirection: isMobile ? "column" : "row",
//           alignItems: isMobile ? "flex-start" : "center",
//           justifyContent: "space-between",
//           gap: "16px",
//           width: "100%"
//         }}
//       >
//         <div>
//           <h2
//             style={{
//               margin: 0,
//               fontSize: isMobile ? "22px" : "26px",
//               fontWeight: "700",
//               color: "#111827",
//               fontFamily: "'Cinzel', serif"
//             }}
//           >
//             Manage Pooja
//           </h2>
//           <p style={{ margin: "4px 0 0 0", fontSize: "14px", color: "#6b7280" }}>
//             {poojas.length} total poojas configured
//           </p>
//         </div>

//         <button
//           onClick={handleOpenAddModal}
//           style={{
//             display: "inline-flex",
//             alignItems: "center",
//             justifyContent: "center",
//             gap: "8px",
//             padding: "10px 20px",
//             borderRadius: "12px",
//             fontSize: "14px",
//             fontWeight: "600",
//             color: "#ffffff",
//             background: "linear-gradient(135deg, #f97316, #c2410c)",
//             boxShadow: "0 4px 16px rgba(249, 115, 22, 0.3)",
//             border: "none",
//             cursor: "pointer",
//             width: isMobile ? "100%" : "auto"
//           }}
//         >
//           {Icons.Plus(16)}
//           <span>Add Pooja</span>
//         </button>
//       </div>

//       {/* Search Toolbar */}
//       <div style={{ display: "flex", width: "100%" }}>
//         <div style={{ position: "relative", flex: 1, maxWidth: isMobile ? "100%" : "420px" }}>
//           <span
//             style={{
//               position: "absolute",
//               left: "14px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               color: "#9ca3af",
//               display: "flex",
//               alignItems: "center"
//             }}
//           >
//             {Icons.Search(16)}
//           </span>
//           <input
//             placeholder="Search poojas…"
//             value={search}
//             onChange={handleSearchChange}
//             style={{
//               width: "100%",
//               padding: "11px 16px 11px 40px",
//               borderRadius: "12px",
//               border: "1px solid #e5e7eb",
//               fontSize: "14px",
//               outline: "none",
//               backgroundColor: "#fdf8f3",
//               color: "#1f2937",
//               boxSizing: "border-box"
//             }}
//           />
//         </div>
//       </div>

//       {/* Main Content / Table */}
//       {loading ? (
//         <div style={{ textAlign: "center", padding: "50px 0", color: "#6b7280", fontSize: "14px" }}>
//           Loading poojas...
//         </div>
//       ) : (
//         <>
//           <div
//             style={{
//               backgroundColor: "#ffffff",
//               borderRadius: "16px",
//               border: "1px solid #ffedd5",
//               boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
//               width: "100%",
//               overflow: "hidden"
//             }}
//           >
//             <div style={{ width: "100%", overflowX: "auto" }}>
//               <table
//                 style={{
//                   width: "100%",
//                   minWidth: "650px",
//                   borderCollapse: "collapse",
//                   textAlign: "left"
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       backgroundColor: "rgba(255, 247, 237, 0.6)",
//                       borderBottom: "1px solid #ffedd5",
//                       fontSize: "12px",
//                       fontWeight: "600",
//                       color: "#374151",
//                       textTransform: "uppercase",
//                       letterSpacing: "0.05em"
//                     }}
//                   >
//                     <th style={{ padding: "14px 20px", width: "70px" }}>S.No</th>
//                     <th style={{ padding: "14px 20px" }}>Pooja Name</th>
//                     <th style={{ padding: "14px 20px", width: "140px" }}>Price</th>
//                     <th style={{ padding: "14px 20px", width: "140px" }}>Duration</th>
//                     <th style={{ padding: "14px 20px", textAlign: "right", width: "110px" }}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody style={{ fontSize: "14px" }}>
//                   {paginatedPoojas.length > 0 ? (
//                     paginatedPoojas.map((pooja, index) => {
//                       const serialNumber = (currentPage - 1) * itemsPerPage + index + 1;
//                       return (
//                         <tr
//                           key={pooja.id}
//                           style={{
//                             borderBottom: "1px solid #fff7ed",
//                             backgroundColor: "#ffffff"
//                           }}
//                         >
//                           <td style={{ padding: "16px 20px", color: "#6b7280", fontWeight: "500" }}>
//                             {serialNumber}
//                           </td>
//                           <td style={{ padding: "16px 20px" }}>
//                             <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                               <div
//                                 style={{
//                                   width: "36px",
//                                   height: "36px",
//                                   borderRadius: "10px",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                   backgroundColor: "#fff7ed",
//                                   fontSize: "18px",
//                                   flexShrink: 0
//                                 }}
//                               >
//                                 🕉️
//                               </div>
//                               <span style={{ fontWeight: "600", color: "#111827" }}>
//                                 {pooja.name}
//                               </span>
//                             </div>
//                           </td>
//                           <td style={{ padding: "16px 20px" }}>
//                             <span style={{ fontWeight: "700", color: "#ea580c" }}>
//                               ₹{pooja.price.toLocaleString()}
//                             </span>
//                           </td>
//                           <td style={{ padding: "16px 20px" }}>
//                             <span
//                               style={{
//                                 display: "inline-block",
//                                 fontSize: "12px",
//                                 fontWeight: "600",
//                                 padding: "4px 10px",
//                                 borderRadius: "9999px",
//                                 backgroundColor: "#fff7ed",
//                                 color: "#c2410c"
//                               }}
//                             >
//                               {pooja.duration}
//                             </span>
//                           </td>
//                           <td style={{ padding: "16px 20px", textAlign: "right" }}>
//                             <div style={{ display: "inline-flex", gap: "8px", justifyContent: "flex-end" }}>
//                               <button
//                                 onClick={() => handleOpenEditModal(pooja)}
//                                 title="Edit Pooja"
//                                 style={{
//                                   width: "34px",
//                                   height: "34px",
//                                   borderRadius: "8px",
//                                   backgroundColor: "#fff7ed",
//                                   color: "#ea580c",
//                                   border: "none",
//                                   cursor: "pointer",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center"
//                                 }}
//                               >
//                                 {Icons.Edit2(14)}
//                               </button>
//                               <button
//                                 onClick={() => handleDeletePooja(pooja.id)}
//                                 title="Delete Pooja"
//                                 style={{
//                                   width: "34px",
//                                   height: "34px",
//                                   borderRadius: "8px",
//                                   backgroundColor: "#fef2f2",
//                                   color: "#ef4444",
//                                   border: "none",
//                                   cursor: "pointer",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center"
//                                 }}
//                               >
//                                 {Icons.Trash2(14)}
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={5}
//                         style={{
//                           textAlign: "center",
//                           padding: "36px 0",
//                           color: "#9ca3af",
//                           fontSize: "14px"
//                         }}
//                       >
//                         No poojas found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* Smart Pagination Controls */}
//           {totalPages > 1 && (
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: isMobile ? "column" : "row",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: "12px",
//                 paddingTop: "8px",
//                 width: "100%",
//                 flexWrap: "wrap"
//               }}
//             >
//               <p style={{ margin: 0, fontSize: "13px", color: "#6b7280" }}>
//                 Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
//                 {Math.min(currentPage * itemsPerPage, filtered.length)} of {filtered.length} poojas
//               </p>

//               <div style={{ display: "flex", alignItems: "center", gap: "4px", flexWrap: "wrap" }}>
//                 {/* First Page */}
//                 <button
//                   onClick={() => setCurrentPage(1)}
//                   disabled={currentPage === 1}
//                   style={{
//                     padding: "6px 10px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: "500",
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     opacity: currentPage === 1 ? 0.4 : 1
//                   }}
//                 >
//                   « First
//                 </button>

//                 {/* Previous */}
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                   disabled={currentPage === 1}
//                   style={{
//                     padding: "6px 12px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: "500",
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     opacity: currentPage === 1 ? 0.4 : 1
//                   }}
//                 >
//                   Prev
//                 </button>

//                 {/* Page Numbers & Ellipsis */}
//                 {getPaginationItems().map((item, index) => {
//                   if (item === "...") {
//                     return (
//                       <span
//                         key={`ellipsis-${index}`}
//                         style={{
//                           display: "inline-flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           width: "28px",
//                           height: "32px",
//                           fontSize: "14px",
//                           color: "#9ca3af",
//                           userSelect: "none"
//                         }}
//                       >
//                         ...
//                       </span>
//                     );
//                   }

//                   const isCurrent = currentPage === item;
//                   return (
//                     <button
//                       key={`page-${item}`}
//                       onClick={() => setCurrentPage(item)}
//                       style={{
//                         minWidth: "32px",
//                         height: "32px",
//                         padding: "0 6px",
//                         borderRadius: "8px",
//                         fontSize: "12px",
//                         fontWeight: isCurrent ? "700" : "500",
//                         cursor: "pointer",
//                         border: isCurrent ? "none" : "1px solid #e5e7eb",
//                         backgroundColor: isCurrent ? "#f97316" : "#ffffff",
//                         color: isCurrent ? "#ffffff" : "#4b5563",
//                         boxShadow: isCurrent ? "0 2px 8px rgba(249, 115, 22, 0.3)" : "none"
//                       }}
//                     >
//                       {item}
//                     </button>
//                   );
//                 })}

//                 {/* Next */}
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
//                   disabled={currentPage === totalPages}
//                   style={{
//                     padding: "6px 12px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: "500",
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === totalPages ? "not-allowed" : "pointer",
//                     opacity: currentPage === totalPages ? 0.4 : 1
//                   }}
//                 >
//                   Next
//                 </button>

//                 {/* Last Page */}
//                 <button
//                   onClick={() => setCurrentPage(totalPages)}
//                   disabled={currentPage === totalPages}
//                   style={{
//                     padding: "6px 10px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: "500",
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === totalPages ? "not-allowed" : "pointer",
//                     opacity: currentPage === totalPages ? 0.4 : 1
//                   }}
//                 >
//                   Last »
//                 </button>
//               </div>
//             </div>
//           )}
//         </>
//       )}

//       {/* Add / Edit Modal */}
//       {showModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             zIndex: 9999,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             padding: "16px",
//             backgroundColor: "rgba(0,0,0,0.45)",
//             backdropFilter: "blur(2px)"
//           }}
//           onClick={() => setShowModal(false)}
//         >
//           <div
//             style={{
//               backgroundColor: "#ffffff",
//               borderRadius: "16px",
//               padding: "24px",
//               width: "100%",
//               maxWidth: "440px",
//               boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
//               boxSizing: "border-box"
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <h3
//               style={{
//                 margin: "0 0 16px 0",
//                 fontSize: "18px",
//                 fontWeight: "700",
//                 color: "#111827",
//                 fontFamily: "'Cinzel', serif"
//               }}
//             >
//               {editingId !== null ? "Edit Pooja" : "Add Pooja"}
//             </h3>
//             <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#374151",
//                     marginBottom: "6px"
//                   }}
//                 >
//                   Pooja Name
//                 </label>
//                 <input
//                   value={poojaName}
//                   onChange={(e) => setPoojaName(e.target.value)}
//                   placeholder="e.g. Rudrabhishek"
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "14px",
//                     outline: "none",
//                     backgroundColor: "#fdf8f3",
//                     color: "#1f2937",
//                     boxSizing: "border-box"
//                   }}
//                 />
//               </div>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#374151",
//                     marginBottom: "6px"
//                   }}
//                 >
//                   Price (₹)
//                 </label>
//                 <input
//                   type="number"
//                   value={price}
//                   onChange={(e) => setPrice(e.target.value)}
//                   placeholder="e.g. 1500"
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "14px",
//                     outline: "none",
//                     backgroundColor: "#fdf8f3",
//                     color: "#1f2937",
//                     boxSizing: "border-box"
//                   }}
//                 />
//               </div>
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#374151",
//                     marginBottom: "6px"
//                   }}
//                 >
//                   Duration
//                 </label>
//                 <input
//                   value={duration}
//                   onChange={(e) => setDuration(e.target.value)}
//                   placeholder="e.g. 2 hrs"
//                   style={{
//                     width: "100%",
//                     padding: "10px 14px",
//                     borderRadius: "10px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "14px",
//                     outline: "none",
//                     backgroundColor: "#fdf8f3",
//                     color: "#1f2937",
//                     boxSizing: "border-box"
//                   }}
//                 />
//               </div>
//             </div>
//             <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
//               <button
//                 type="button"
//                 onClick={() => setShowModal(false)}
//                 style={{
//                   flex: 1,
//                   padding: "10px 16px",
//                   borderRadius: "10px",
//                   border: "1px solid #e5e7eb",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   color: "#4b5563",
//                   backgroundColor: "#ffffff",
//                   cursor: "pointer"
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 onClick={handleSavePooja}
//                 style={{
//                   flex: 1,
//                   padding: "10px 16px",
//                   borderRadius: "10px",
//                   border: "none",
//                   fontSize: "14px",
//                   fontWeight: "600",
//                   color: "#ffffff",
//                   background: "linear-gradient(135deg, #f97316, #c2410c)",
//                   cursor: "pointer"
//                 }}
//               >
//                 {editingId !== null ? "Update Pooja" : "Save Pooja"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }